export enum ClaimProcessingSystemName {
    ApproveClaim = 'approveclaim',
    ApproveClaimFinalise = 'approveClaimFinalise',
    /** Return-for-rework (resubmit allowed). Legacy wire value 'rejectclaim' kept for back-compat. */
    ReturnClaim = 'rejectclaim',
    /** Terminal reject (no resubmit). Value 'declineclaim' since 'rejectclaim' is taken by ReturnClaim. */
    RejectClaim = 'declineclaim',
    SubmitClaim = 'submitclaim',
    ForceApproveClaim = 'forceApproveClaim',
    /** Terminal reject of a claim the contractor has not submitted yet (WBS-10633). Same effect as RejectClaim — a separate action only so the unusual intent is named in the UI and gated on the unsubmitted claim labels. */
    ForceRejectClaim = 'forceRejectClaim'
}

/** Claim actions supported by tenant-side bulk claim processing (WBS-10016/WBS-10306/WBS-10633). */
export const BulkClaimProcessingActions = [
    ClaimProcessingSystemName.ApproveClaim,
    ClaimProcessingSystemName.ApproveClaimFinalise,
    ClaimProcessingSystemName.ReturnClaim,
    ClaimProcessingSystemName.RejectClaim,
    ClaimProcessingSystemName.ForceApproveClaim,
    ClaimProcessingSystemName.ForceRejectClaim
] as const;

export type BulkClaimProcessingAction = typeof BulkClaimProcessingActions[number];

export enum ClaimProcessingStatus {
    ClaimReceived = 'Claim Received',
    ClaimPending = 'Claim Pending',
    ClaimSubmitted = 'Claim Submitted',
    ClaimResubmitted = 'Claim Resubmitted',
    ClaimReturned = 'Claim Returned',
    ClaimApproved = 'Claim Approved',
    ClaimRejected = 'Claim Rejected'
};

export const ClaimProcessingActions = Object.values(ClaimProcessingSystemName) as string[];
